import breadcrumbs from "@/views/modules/Applications/MenuList.vue";
import lang from "@/views/modules/Applications/language/en";
import tinymce from 'vue-tinymce-text-editor';
import Datepicker from 'vuejs-datepicker';
import loader from "@/views/shared/loading/Loading.vue";
import vSelect from "vue-select";
import DownloadFile from "@/plugins/download_file.js";
import alert from "@/views/shared/notify/Alert.vue";

export default {
    name: "edit-applications",

    components: {
        breadcrumbs,
        Datepicker,
        loader,
        vSelect,
        'tinymce': tinymce,
        alert,
    },
    data() {
        return {
            loading: true,
            stageBtn:false,
            mailBtn:false,
            mailProcess:false,
            showButton:true,
            status: '',
            stagelabel: '',
            deleteProductModal: false,
            dataList: {},
            Opportunity: {},
            lang: [],
            showEdit: false,
            edit: true,
            close: false,
            budgetHead: [],
            budgetItem: [],
            tdYear: 1,
            year1: true,
            year2: false,
            year3: false,
            year4: false,
            year5: false,
            year6: false,
            year7: false,
            year8: false,
            year9: false,
            year10: false,
            templateData: [],
            currencyName:'',
            multiplier:'',
            other_currency:0,
            formObj: {
                app_budget_id: "",
            },
            template_id: "",
            app_temp_id: "",
            leftArr: [],
            rightArr: [],
            commentsList: [],
            activitiesList: [],
            activitiesListitems: [],
            customLoading: false,
            comment: '',
            usersList: [],
            usersEmailList:[],
            taggedUser: [],
            // reminder: {
            //     users: []
            // },
            // remindersList: [],
            applicationBudget: [],
            showBudget: false,
            leftLoading: false,
            rightLoading: false,
            customLoading: false,
            totalInr: 0,
            dom_array: [],
            processing: false,
            docProcess:false,
            currentUrl: '',
            download_loading: false,
            downlaod_create: true,
            download_zip: '',
            notLinkWP:'',
            teammember: {
                assigned_user_id: '',
                mobile: '',
                professional: '',
                description: ''
            },
            teamList: [],
            confirm_label: 'Confirm',
            page: 1,
            search: '',
            sort: {
                order: 'desc',
                column: 'date_entered',
            },
            perPage: 10,
            
            current_url:'',
            documentList:[],
            allDocs:[],
            docName:'',
            uploadDocs:false,
            PI_Role:false,
            RM_Role:false,
            ABANDONED:'Abandon',
            RESUME:'Resume',
            selected:false,
            sendMail:{
                tousers:[],
                ccusers:[],
                subject:'',
                mailbody:'',
                application_id:'',
            },
            options: {
                height: this.height || 350
            },

            reviewerDocs:[],
            reviewerShow:false,
            defaultObj:{},
            editableChk:false,
            strategic_priority:[],
            s_priority:[],
            budgetFile:[],
            budgetFileName:'',
            showBudgetFileName:'',
            UploadBudgetFile:false,
            budgetFiles:[],
            budgetPath:'',
            bt_msg:'',
            show_bt_msg:false,
            templateName:'export',
            file_error:'',
        }
    },
    mounted() {
        this.getProduct();
        this.getBudget();
        this.getUserList();
        this.loadTeamMember();
        this.updateNotification();
        this.currentUrl = window.location.origin;
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
       
        let userData = JSON.parse(localStorage.getItem('user_prefrence'));
        
        if(userData.user_type == 'PI' || userData.user_type == 'Super Admin'){
            this.stageBtn = true;
            this.reviewerShow = true;
        }else{
            this.stageBtn = false;
            this.reviewerShow = false;
        }

        if(userData.user_type == 'RM' || userData.user_type == 'Super Admin' || userData.user_type == 'ED' || userData.user_type == 'FM'){
            this.mailBtn = true;
            this.reviewerShow = true;
            this.stageBtn = true;
        }else{
            if(userData.user_type != 'PI')
            {
            this.mailBtn = false;
            this.reviewerShow = false;
            this.stageBtn = false;
            }
        }
        this.current_url = window.app.app_url;
        
    },
    computed: {
        hours() {
            return Array.from({ length: 12 }, (_, index) => (index + 1).toString().padStart(2, '0'));
        },
        minutes() {
            return Array.from({ length: 60 }, (_, minute) => minute.toString().padStart(2, '0'));
        }
    },
    methods: {
        updateNotification() {
            const self = this;
            self.loading = true;
            let postData = {
                parent_id:self.$route.params.id,
                parent_type:'Applications',
            }
            axios.post('api/modules/notifications/read-notification', postData).then(function (response) {
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        getProduct() {
            const self = this;
            //self.loading = true;
                window.currentAction = 'view';
                axios.get('api/modules/applications/' + self.$route.params.id).then(function (response) {
                self.dataList = response.data;
                self.templateName = self.dataList.application_title+'_'+self.dataList.created_by;
                self.strategic_priority = self.dataList.strategic_priority;
                self.s_priority = self.dataList.strategic_priority;
                let userData = localStorage.getItem('user_prefrence');
                let users = JSON.parse(userData);
                if(users.user_type == 'PI' || users.user_type == 'Super Admin' || users.user_type == 'RM'){
                    self.PI_Role = true;
                    self.RM_Role = true;
                }else{
                    self.PI_Role = false;
                    self.RM_Role = false;
                }

                if(self.dataList.status == 'Abandoned' ){
                    
                    self.RESUME = 'Resume';
                    self.ABANDONED = ''; 
                    self.selected = true;                   
                }else if(self.dataList.status == 'Submitted'){
                    self.showButton = false;
                }else{
                   
                    self.RESUME = '';
                    self.ABANDONED = 'Abandon';
                    self.selected = false;
                }
                let current_path = window.location.host;
                
                /* self.sendMail.mailbody = '<p>Dear reviewer</p>'
                                        +'<p>Greetings of the day! Thanks for accepting our request to review the grant.</p>'
                                        +'<p>The researcher has uploaded the documents at this link in the grants management system page.</p>'
                                        +'<p>1. Document Upload Link <a href="http://'+current_path+'/modules/reviewerdocuments/detail?parent_id='+self.$route.params.id+'&action=detail">Download Link</a></p>'
                                        +'<p>Clicking on the link will take you to the system page where you will be able to download the review document. Once done, Please upload the file with your comments at the upload document link on the right hand panel.</p>'
                                        +'<br><p>Kindly review the document by (1 week)<br/></p>'
                                        +'<p>Thanks and best wishes,<br/>Research Services and Strategy team</p></p>'
                self.sendMail.subject = "Application review request: ("+self.dataList.app_no + ") " + self.dataList.application_title;
                self.sendMail.application_id = self.$route.params.id; */

               // self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        deleteProduct() {
            const self = this;
            window.currentAction = 'delete';
            axios.delete('api/modules/applications/' + self.$route.params.id).then(function () {
                self.$router.push('/modules/products');
            }).catch(function () {
                self.loading = false;
                self.deleteProductModal = false;
            });
        },
        editEnable(chk) {
            const self = this;
            if (chk == 'edit') {
                self.showEdit = true;
                self.edit = false;
                self.close = true;
            } else {
               
                self.updateApplication();
            }

        },
        updateApplication() {
            const self = this;
            let application_title = document.getElementById("application_title").value;
            
            let application_note = document.getElementById("application_note").value;

            let formData = {
                'app_id': self.$route.params.id,
                'application_title': application_title,
                'strategic_priority': self.strategic_priority,
                'application_note': application_note,
            }
            window.currentAction = 'edit';
            axios.post('api/modules/update_application', formData).then(function (response) {
                self.showEdit = false;
                self.edit = true;
                self.close = false;
                self.getProduct();
                self.getBudget();
                self.getUserList();                
            }).catch(function (error) {
                self.loading = false;
                self.process = false;
                let allerror = document.getElementsByClassName('error');
                for(let i = 0; i < allerror.length; i++)
                {
                    allerror[i].innerHTML = '';
                }
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                Object.keys(err_msg2 || {}).forEach((key) => {
                    let errorval = err_msg2[key];
                   
                    let error_el = document.getElementById(key+"_error");
                        error_el.innerHTML = errorval
                });
                localStorage.removeItem('Errors');
            }); 
        },
        openTemplate(opportunity_id = "", application_id = "", app_template = "") {
            const self = this;
            self.formObj.app_budget_id = app_template;
            self.leftLoading = true;
            self.rightLoading = true;
            $("#budgetModal").modal("show");
            //self.Opportunity = self.dataList;
            let url = "";
            if (app_template == "") {
                url = 'api/modules/getopp_budget';
            }
            if (app_template != '') {
                url = 'api/modules/getapp_budget';
            }
           
            axios.get(url, { params: { 'opportunity_id': opportunity_id, 'application_id': application_id, 'app_template_id': app_template } }).then(function (response) {
                
                if (response.data.message) {
                    self.show_bt_msg = true;
                    self.bt_msg = response.data.message;
                }else{
                self.show_bt_msg = false;
                self.bt_msg = '';
                }
                self.tdYear = response.data.template.templates[0].template_year;
                
                self.template_id = response.data.template.templates[0].id;
                
                if(typeof response.data.app_template[0] == 'undefined'){
                    self.formObj.app_budget_id = response.data.app_template.id;
                }else{
                    self.formObj.app_budget_id = response.data.app_template[0].id;
                }
               
                if (self.tdYear == 2) {
                    self.year2 = true;
                }
                if (self.tdYear == 3) {
                    self.year2 = true;
                    self.year3 = true;
                }
                if (self.tdYear == 4) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                }
                if (self.tdYear == 5) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                }
                if (self.tdYear == 6) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                }
                if (self.tdYear == 7) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                }
                if (self.tdYear == 8) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                }
                if (self.tdYear == 9) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = true;
                }
                if (self.tdYear == 10) {
                    self.year2 = true;
                    self.year3 = true;
                    self.year4 = true;
                    self.year5 = true;
                    self.year6 = true;
                    self.year7 = true;
                    self.year8 = true;
                    self.year9 = true;
                    self.year10 = true;
                }
                
                self.budgetHead = response.data.data1;
                self.budgetItem = response.data.data2;
                self.templateData = response.data.template.templates;
                self.currencyName = response.data.template.templates[0].currency_name;
                self.multiplier = response.data.template.templates[0].currency_multiplier;
                self.leftLoading = false;
                self.rightLoading = false;
                self.calculateGrandTotal(response.data.app_template[0].id);
            }).catch(function () {
                self.leftLoading = false;
                self.rightLoading = false;
            });
        },
        moveData(side) {
            const self = this;
            self.leftLoading = true;
            self.rightLoading = true;
            var id = [];
            $('.leftCheckBox:checked').each(function (i) {
                if (id == '') {
                    id[i] = $(this).val();
                } else {
                    id[i] = $(this).val();
                }

            });
            let arr = {};
            for (let i = 0; i < id.length; i++) {
                let items = id[i].split("_");
                let head_id = items[0];
                let item_id = items[1];
                let item_name = items[2];
                let narration = items[3];
                let is_changeable = items[4];
                let sequence_no = items[5];
                if (side == 'left') {
                    arr = { 'head_id': head_id, 'item_id': item_id, 'item_name': item_name, 'narration':narration, 'is_changeable':is_changeable, 'sequence_no':sequence_no};
                } else {
                    arr = { 'head_id': head_id, 'item_id': item_id, 'item_name': item_name };
                }

                self.leftArr.push(arr);
            }

            if (self.leftArr.length > 0) {
                let opportunity_id = document.getElementById("opportunity_id").value;
                let app_id = self.$route.params.id;
                let left_array = {
                    'side': side,
                    'right_arr': self.leftArr,
                    'form': {
                        'app_temp_id': self.formObj.app_budget_id,
                        'app_id': app_id,
                        'budget_template_id': self.template_id,
                        'opportunity_id': opportunity_id,
                    }
                };
                self.itemloading = true;
                axios.post('api/modules/moveright_app', left_array).then(function (response) {
                    self.leftArr = [];
                    self.getLeftData(opportunity_id, app_id);
                    self.getRightData();

                })


            } else {
                self.$refs.notifyMsg.showAlert('Error','Please select at least one option from budget head');
                self.leftLoading = false;
                self.rightLoading = false;
            }
        },
        checkall(headid, cname) {
            let head = cname.split("-");
            if ($("#" + head[0] + "_head_" + headid).is(":checked")) {
                let elName = document.getElementsByClassName(cname + "_" + headid);
                for (let i = 0; i < elName.length; i++) {
                    document.getElementById(elName[i].id).checked = true;
                }
            } else {
                let elName = document.getElementsByClassName(cname + "_" + headid);
                for (let i = 0; i < elName.length; i++) {
                    document.getElementById(elName[i].id).checked = false;
                }
            }
        },
        loadComments() {
            const self = this;
            let searches = {
                'parent_type': 'Applications',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'comment';
                axios.get('api/modules/comments', { params: { search: searches, perPage: '999999999999', calling_from:'comments', 'action':'list'} }).then(function (response) {
                self.commentsList = response.data.items.reverse();
                self.customLoading = false;
            })
        },
        loadActivities() {
            const self = this;
            let searches = {
                'parent_type': 'Applications',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'activity';
            
                axios.get('api/modules/comments', { params: { search: searches, perPage: '999999999999', calling_from:'activity_stream', 'action':'list' } }).then(function (response) {
                var activitiesListData = {};
                const activitiesListitems = response.data.items;
                activitiesListitems.forEach(entry => {
                    const date = self.extractDate(entry.date_entered);
                    if (activitiesListData[date]) {
                        activitiesListData[date].push(entry);
                    } else {
                        activitiesListData[date] = [entry];
                    }
                });
                self.customLoading = false;
                self.activitiesList = activitiesListData;
            })
        },
        extractDate(dateString) {
            const dateObj = moment(dateString, 'DD/MM/YYYY h:mma');
            const formattedDate = dateObj.format('DD/MM/YYYY');
            return formattedDate;
        },
        addComments() {
            const self = this;
            let formData = {
                'parent_type': 'Applications',
                'parent_id': self.$route.params.id,
                'description': self.comment,
                'taggedUser': self.taggedUser,
            }
            if (self.comment === '') {
                self.$refs.notifyMsg.showAlert('Error','comment can not be empty');
                return false;
            }
            self.customLoading = 'addComment';
            window.currentAction = 'edit'
            axios.post('api/modules/comments', formData).then(function (response) {
                self.loadComments();
                self.comment = '';
                self.taggedUser = [];
                document.getElementById("comment").value = '';
                let allerror = document.getElementsByClassName('error');
                for(let i = 0; i < allerror.length; i++)
                {
                    allerror[i].innerHTML = '';
                }
                self.customLoading = false;
            }).catch(error => {
                let allerror = document.getElementsByClassName('error');
                for(let i = 0; i < allerror.length; i++)
                {
                    allerror[i].innerHTML = '';
                }
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                Object.keys(err_msg2 || {}).forEach((key) => {
                    let errorval = err_msg2[key];                      
                    let error_el = document.getElementById(key+"_error");
                        error_el.innerHTML = errorval
                });
                localStorage.removeItem('Errors');
                self.customLoading = false;
            })
        },

        addTeamMember() {
            const self = this;
            let parent_id = self.$route.params.id;
            
            axios.post('api/modules/teammembers', { 'editFormData': self.teammember, 'parent_id': parent_id }).then(function (response) {

                self.customLoading = false;
                self.teammember.users = [];
                $("#teamMemberModal").modal("hide");

                self.loadTeamMember();

            }).catch(error => {
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];                      
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
            })
        },
        deleteTeamMember(recordId) {
            const self = this;
            self.customLoading = 'invitee';
            const deleteRecord = { 'delete_id': recordId };
            window.currentAction = 'delete';
            axios.post('api/modules/teammembers/remove', deleteRecord).then(function () {
                self.customLoading = false;
                self.loadTeamMember();
            });
        },
        getUserList() {
            const self = this;
            window.currentAction = 'detail';
            axios.post('api/modules/users/select').then(function (response) {

                self.usersList = response.data.items.map(item => ({
                    id: item.id,
                    dname: `${item.name} (${item.email})`,
                    name: item.name,
                }));

                self.usersEmailList = response.data.items.map(item => ({
                    id: item.id,
                    uemail: `${item.name} (${item.email})`,
                    email: item.email,
                }));
            })
        },

        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
            //  return moment(date).format('DD/MM/yyyy hh:mm:ss a');
        },
        // handleReminderTypeChange() {
        //     if (this.reminder.reminder_type !== 'On Due Date') {
        //         this.reminder.reminder_date = ''; // Clear the reminder date value
        //     }
        // },
        formatTime(hours, minutes, period) {
            let formattedTime = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':00';
            formattedTime += period === 'am' ? 'AM' : 'PM';
            return formattedTime;
        },
        /* saveReminder() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;
            self.customLoading = 'reminder';
            self.reminder.parent_type = 'Applications';
            self.reminder.parent_id = self.$route.params.id;
            self.reminder.reminder_time = self.formatTime(self.reminder.hours, self.reminder.minutes, self.reminder.period);
            axios.post('api/modules/reminders', self.reminder).then(function (response) {
                self.customLoading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.reminder = {};
                self.loadReminders();
                self.reminder.users = [];
            }).catch(function (response) {
                self.customLoading = false;

                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
        loadReminders() {
            const self = this;
            let searches = {
                'parent_type': 'Applications',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'reminder';
             window.currentAction = 'list';
                axios.get('api/modules/reminders', { params: { search: searches, perPage: '999999999999' } }).then(function (response) {
                self.remindersList = response.data.items;
                self.customLoading = false;
            })
        }, */
        getBudget() {
            const self = this;
            let items = '';
                axios.get('api/modules/getappbudget', { params: { 'app_id': self.$route.params.id, 'action':'list' } }).then(function (response) {

                self.applicationBudget = response.data.items;
                self.budgetFiles = response.data.link_budget;
                self.currentUrl = window.location.origin;
                self.budgetPath = response.data.doc_path;
                items = response.data;

                if (items != '') {
                    self.showBudget = true;
                }

            }).catch(function (res) {
                console.log("application  budget not found")
            })
        },
        getLeftData(opportunity_id, application_id) {
            const self = this;
                axios.get('api/modules/getBudgetHead', { params: { 'AllHead': 'AllHead', 'opportunity_id':opportunity_id, 'application_id':application_id, 'action':'list'} }).then(function (response) {

                self.budgetHead = response.data;
                self.leftLoading = false;
            })
        },

        getRightData() {
            const self = this;
            
                axios.get('api/modules/getappbudgetitem', { params: { 'app_id': self.$route.params.id, 'action':'list' } }).then(function (response) {

                self.budgetItem = response.data.items;
                self.rightLoading = false;
                self.calculateGrandTotal(self.formObj.app_budget_id);
            })
        },

        updateColumn(col_value, head_id, col_id, col_name) {
            const self = this;
           
            let col_obj = { 'col_value': col_value, 'head_id': head_id, 'col_id': col_id, 'col_name': col_name };
           
            axios.post('api/modules/update_col', col_obj).then(function (response) {

                document.getElementById("head_inr_" + head_id).innerHTML = response.data.head_total;
                document.getElementById("head_usd_" + head_id).innerHTML = response.data.head_usd;

                document.getElementById("Ghead_inr_" + head_id + "_1").innerHTML = response.data.head_total;
                document.getElementById("Ghead_usd_" + head_id + "_1").innerHTML = response.data.head_usd; 
                self.getRightData();
            })
        },

        openOpportunity(oppid, modal_id) {
            const self = this;
            $("#" + modal_id).modal("hide");
            self.$router.push('/modules/opportunitys/' + oppid + '/detail');
        },

        calculateGrandTotal(app_template_id) {
            const self = this;
            let totalinr = 0;
            let otherCurrency  = 0;
            
            let templateData = {'app_temp_id': app_template_id};
            axios.post('api/modules/gettotalinrapp', templateData).then(function (response) {

                //self.formObj.grand_total_inr = response.data.total_inr;
                if (response.data.total_inr > 0) {
                    totalinr = response.data.total_inr;
                }
                self.totalInr = totalinr;

                if(totalinr > 0){
                    otherCurrency = parseFloat(totalinr / self.multiplier).toFixed(2);
                }
                self.other_currency = otherCurrency;

            })
        },

        saveBudget(app_template_id, action='') {
            const self = this;              
            axios.post('api/modules/saveappbudget', { 'app_temp_id': app_template_id, 'budgetData':self.budgetItem}).then(function (response) {
                
                if(action == '')
                {
                    $("#budgetModal").modal("hide");
                    self.getBudget();
                }
                if(action == 'OnlySave')
                {
                    self.$refs.notifyMsg.showAlert('Success','Budget is saved successfully!');
                }
            })
        },

        customFormatter(date) {
            return moment(date).format('DD/MM/yyyy');
        },

        changeFile(e) {
            let filelist = e.target.files;
            const fileInput = e.target;
            this.allFiles = [];
            this.file_error = '';
            const files = Array.from(fileInput.files);
            if (!files.length) return;
            // ----------------------------
            // 1. FILE COUNT VALIDATION
            // ----------------------------
            const MAX_FILES = 5;
            if (files.length > MAX_FILES) {
                this.file_error = "You can upload a maximum of 5 files only.";
                fileInput.value = '';
                return;
            }
                //console.log(window.app.max_file_size);
            for (let i = 0; i < filelist.length; i++) {
                let image = e.target.files[i];
                // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    this.file_error = `File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;
                    fileInput.value = '';
                    this.allFiles = [];
                    return;
                }

                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.fileName = file_type_arr;
                this.showFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes

                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }

                if(fileSize <= definedSize)
                {
                    this.file_error = '';
                    let reader = new FileReader();
                    reader.readAsDataURL(image);
                    reader.onload = e => {
                        //  this.file_content = e.target.result;
                        this.fileUpload = true;
                        fileArr.push(e.target.result, this.fileUpload, file_type_arr[1], image.name);
                        this.allFiles.push(fileArr);
                    };
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }
            }

        },
       
        UploadFile() {
            const self = this;
            let count = 0;
            let app_id = self.$route.params.id;
            if(self.file_error == '' && self.allFiles.length > 0)
            {
                self.processing = true;
                for (let i = 0; i < 95; i++) {
                    self.loadProgress(i);
                }
                axios.post('api/modules/applications/uploadFile', { 'app_id': app_id, 'filelist': self.allFiles, headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {
                    if (res.data.message != '') {
                        
                        self.loadProgress(95);
                        self.loadProgress(96);
                        self.loadProgress(97);
                        self.loadProgress(98);
                        self.loadProgress(99);
                        count = self.loadProgress(100);
                        if (count == 100) {
                            $("#upload_work").val("");
                            $(".progress-bar").animate({
                                width: "0%",
                            }, 0);
                            $("#uploadFileModal").modal("hide");
                            self.processing = false;
                            self.getProduct();
                        }
                    }
                }).catch(function (err) {
                    self.loading = false;
                    self.processing = false;
                });
            }else{
                self.file_error = "Please select appropriate file";
            }
        },
        loadProgress(widthBar) {

            $(".progress-bar").animate({
                width: widthBar + "%",
            }, 0);
            if (widthBar == 100) {
                return widthBar;
            }
        },
        downloadWorkpackage(opportunity_id) {
            const self = this;
            self.download_loading = true;
            self.downlaod_create = true;
            axios.post('api/modules/workpackages/download_workpackage', { 'opportunity_id': opportunity_id }).then(function (response) {

                if (response.data.zipfile) {
                    self.download_loading = false;
                    self.downlaod_create = false;
                    self.download_zip = response.data.zipfile;
                }else{
                    self.download_loading = false;
                    self.downlaod_create = false;
                    self.notLinkWP = response.data.message;
                }
            })
        },
        loadTeamMember() {
            const self = this;
            let searches = {
                'parent_type': 'Applications',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'team_member';
                axios.get('api/modules/teammembers', 
                { params: { search: searches, perPage: '999999999999', 'action':'list' } }).then(function (response) {
                self.teamList = response.data.items;

                self.customLoading = false;
            })
        },
        openStageModal(status) {
            const self = this;
            self.loadFinalDocument();
            self.status = false;
            self.stagelabel = status;
            let userData = JSON.parse(localStorage.getItem('user_prefrence'));
            var valistage = '';
            if((self.stagelabel == 'Application ready for review' || self.stagelabel == 'Under review') && userData.user_type == 'PI')
            {
                self.$refs.notifyMsg.showAlert('Error','Please contact to Research Manager to change state');
            }else{
                const nextStage = self.getNextStage(self.dataList.status);

                if (self.stagelabel !== self.dataList.status) {
                    
                    self.$refs.notifyMsg.showAlert('Error','Action is not allowed');
                    return false;
                }

                if (self.stagelabel === 'Technical review') {
                    self.confirm_label = 'Ready for peer review'
                }
                if (self.stagelabel === 'FM review') {
                    self.confirm_label = 'ready for finance review'
                }

                var myModal = new bootstrap.Modal(document.getElementById('stageModal'));

                myModal.show();
            }
        },
        updateStatus() {
            const self = this;
            let finalCheck = false;
            var app_id = self.$route.params.id;
            let documentCount = self.documentList.length;
            let oldStage = self.stagelabel;

            if (self.status === false) {
                
                self.$refs.notifyMsg.showAlert('Error','please confirm the checkbox');
                return false;
            }
          
            if(self.stagelabel == 'Pending submission' && documentCount > 0){
                finalCheck = true;
            }else{
                finalCheck = false;
            }
            
             if(oldStage !='Pending submission' && finalCheck == false){
                self.stagelabel = self.getNextStage(self.dataList.status);
               
                axios.post('api/modules/updatedbcolumn', { 'record': app_id, 'column_name': 'status', 'col_value': self.stagelabel }).then(function (response) {
                    var resdata = response.data
                    self.dataList.status = self.stagelabel;
                })
                $('#stageModal').modal('hide');
            }

            else if(oldStage == 'Pending submission' && documentCount > 0 && finalCheck == true){
                self.stagelabel = self.getNextStage(self.dataList.status);                
                    axios.post('api/modules/updatedbcolumn', { 'record': app_id, 'column_name': 'status', 'col_value': self.stagelabel }).then(function (response) {
                        var resdata = response.data
                        self.dataList.status = self.stagelabel;
                    })
                    $('#stageModal').modal('hide');
                }else{
                    
                    self.$refs.notifyMsg.showAlert('Error','Please upload final document first');
                    document.getElementById("status").checked = false;
                    $('#stageModal').modal('hide');
                }

        },

        getNextStage(currentStage) {
            if (currentStage === 'Under development') {
                return "Application ready for review";
            }
            const self = this;
            const stagesArray = Object.entries(self.dom_array.application_stages);
            const currentIndex = stagesArray.findIndex(([key, value]) => value.name === currentStage);

            if (currentIndex !== -1 && currentIndex < stagesArray.length - 1) {
                const [nextKey, nextValue] = stagesArray[currentIndex + 1];
                return nextKey;
            }

            return null;
        },
        getStagesBefore(currentStage) {
            const stagesArray = Object.entries(this.dom_array.application_stages);
            const stagesBefore = [];
            /* if (currentStage === 'Under development') {
               let value = 'Application ready for review';
               let key = 'Application ready for review';
                stagesBefore.push({ key, value });
                return stagesBefore;
            } */
            for (const [key, value] of stagesArray) {
                if (value.name === currentStage) {
                    break;
                }
                stagesBefore.push({ key, value });

            }
            return stagesBefore;
        },
       
        showMailBody(text){
            let firstTwentyWords = text.slice(0, 50); // create a sub-array of 20 words
            //let firstTwentyWordsJoined = firstTwentyWords.join(" ");

            return firstTwentyWords+".....";
        },
        loadFinalDocument(){
            const self = this;
            let searches = {
                'parent_type': 'Applications',
                'parent_id': self.$route.params.id,
            }
            self.customLoading = 'final_document';
                axios.get('api/modules/finaldocuments', { params: { search: searches, perPage: '999999999999', 'action':'list' } }).then(function (response) {
                self.documentList = response.data.items;

                self.customLoading = false;
            })
        },
        UploadDocument(){
            const self = this;
            
            if(self.allDocs.length > 0 && self.file_error == ''){
            self.docProcess = true;
            let count = 0;
            let app_id = self.$route.params.id;
            for (let i = 0; i < 95; i++) {
                self.docProgress(i);
            }

            let error_el = document.getElementById("filename_error");
            error_el.innerHTML = "";
            axios.post('api/modules/finaldocuments/uploadDocument', { 'app_id': app_id, 'filelist': self.allDocs, headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {

                if (res.data.message != '') {
                    
                    self.docProgress(95);
                    self.docProgress(96);
                    self.docProgress(97);
                    self.docProgress(98);
                    self.docProgress(99);
                    count = self.docProgress(100);
                    if (count == 100) {
                        $("#upload_work").val("");
                        $(".progress-bar").animate({
                            width: "0%",
                        }, 0);
                        $("#finalDocumentModal").modal("hide");
                        self.docProcess = false;
                        //self.getProduct();
                        self.loadFinalDocument();
                    }
                }
            }).catch(function () {
                self.loading = false;
                self.docProcess = false;
                });
            }else{
                
                let error_el = document.getElementById("filename_error");          
                error_el.innerHTML = "Please select at least one file to upload";
            }
        },
        finalDocumentModal(){
            const self = this;
            self.file_error = '';
            let error_el = document.getElementById("filename_error");
            let upload_document = document.getElementById("upload_document");
            error_el.innerHTML = "";
            upload_document.value = "";
            $("#finalDocumentModal").modal("show");
        },
        changeDocumnet(e){
            let filelist = e.target.files;
            const fileInput = e.target;
            this.allDocs = [];
            this.file_error = '';
            const files = Array.from(fileInput.files);
            if (!files.length) return;
            // ----------------------------
            // 1. FILE COUNT VALIDATION
            // ----------------------------
            const MAX_FILES = 5;
            if (files.length > MAX_FILES) {
                this.file_error = "You can upload a maximum of 5 files only.";
                fileInput.value = '';
                return;
            }

            for (let i = 0; i < filelist.length; i++) {
                let image = e.target.files[i];
                 // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    this.file_error = `File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;
                    fileInput.value = '';
                    this.allDocs = [];
                    return;
                }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.docName = file_type_arr;
                // Get the file size
                let fileSize = image.size; // in bytes
                
                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }

                if(fileSize < definedSize)
                {
                    this.file_error = '';
                    let reader = new FileReader();
                    reader.readAsDataURL(image);
                    reader.onload = e => {
                        //  this.file_content = e.target.result;
                        this.uploadDocs = true;
                        fileArr.push(e.target.result, this.uploadDocs, file_type_arr[1], image.name);
                        this.allDocs.push(fileArr);
                    };
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }

            }
        },
        docProgress(widthBar) {

            $(".doc-progress").animate({
                width: widthBar + "%",
            }, 0);
            if (widthBar == 100) {
                return widthBar;
            }
        },
        downloadFile(filePath, fileName){
            const filepath = new DownloadFile();
            let url = filepath.getFilePath(filePath, fileName);
            window.open(url, '_blank');              
        },
        deleteDocument(record_id){
            const self = this;
            const deleteRecord = {'delete_id':record_id};

            axios.post('api/modules/finaldocuments/remove', deleteRecord).then(function(response){
                self.loadFinalDocument();
            }).catch(function(error){
                self.loading = false;
            });
        },
        updateStages(){
            const self = this;
            let StageValue = '';
            if($("#stage_check").is(":checked")){
                
                self.selected = true;
                self.RESUME = 'Resume';
                self.ABANDONED = '';
                StageValue = 'Abandoned';
            }else{
                
                self.selected = false;
                self.RESUME = '';
                self.ABANDONED = 'Abandon';
                StageValue = 'Resume';
            }

            let stageData = {
                'stageValue':StageValue,
                'application_id':self.$route.params.id
            }

            axios.post('api/modules/applications/updatestages', stageData).then(function(response){
              //  console.log(response.data)//previous_status
                self.getProduct();
                self.getBudget();
                self.getUserList();
                self.loadTeamMember();
                self.updateNotification();
            }).catch(function(e){
                console.log(e);
            })
        },
        sendAppEMail(){
            const self = this;
            //self.disabled = true;
                self.processing = true;
                self.mailProcess = true;
            axios.post('api/modules/reviewerdocuments/sendreviewermail', {'formData':self.sendMail,'filelist':[], headers: { 'Content-Type': 'multipart/form-data' }}).then(function(res){
                
                self.disabled = false;
                self.processing = false;
                self.mailProcess = false;
                self.loading = false;
                if(res.data.message !=''){
                    $("#sendEmailModal").modal("hide");
                    self.sendMail.tousers = [];
                    self.sendMail.ccusers = [];
                    if(self.loading == false){
                        setTimeout(function(){
                            self.$refs.notifyMsg.showAlert('Success', res.data.message);
                           
                        }, 1000);
                    }
                }
                    }).catch(function () {
                self.loading = false;
                });
            },
            setMailBody(){
                const self = this;
                let current_path = window.location.host; 
                self.sendMail.mailbody = '<p>Dear reviewer</p>'
                +'<p>Greetings of the day! I am writing to you in connection to '+self.dataList.created_by+' application to the '+self.dataList.opportunity_title+' competition.</p>'
                +'<p>Would you be able to review this proposal by <a href="http://'+current_path+'/modules/reviewerdocuments/detail?parent_id='+self.$route.params.id+'&action=detail">Document Upload Link</a> availability at this link.</p>'
                +'<p>In case you are unable to review, please mark decline to prevent receiving reminders from the system.</p>'
                +'<p>You can download the the proposal from the same page. After adding your comments to the proposal, please upload the draft at the upload docment link to complete the process.</p>'
                +'<br><p>Kindly review the document by (1 week)<br/></p>'
                +'<p>Thanks and best wishes,<br/>Research Services and Strategy team</p></p>'
                //self.sendMail.subject = "Application review request: ("+self.dataList.app_no + ") " + self.dataList.application_title;
                self.sendMail.subject = "PAMS: Review request for "+self.dataList.opportunity_title;
                self.sendMail.application_id = self.$route.params.id;
            },
        loadReviewerDocument(){
            const self = this;
            let AppObj = {'app_id':self.$route.params.id, 'action':'list'};
                axios.get('api/modules/applications/getalldocument', {params:AppObj}).then(function(response){               
                self.reviewerDocs = response.data.reviewer_doc;
            }).catch(function(e){
                console.log(e);
            })
        },
        enableEdit(i, rowid){
            const self = this;
            let editBtn = document.getElementById("editname_"+i);
            let valueEl = document.getElementById("other_"+rowid);
            editBtn.classList.add("d-none");
            valueEl.classList.add("editable-box");
            self.editableChk = true;
        },
        updateName(rowid, i){
            const self = this;
           
            let editBtn = document.getElementById("editname_"+i);
            let valueEl = document.getElementById("other_"+rowid);
            editBtn.classList.remove("d-none");
            valueEl.classList.remove("editable-box");
            self.editableChk = false;
            let itemName = document.getElementById("other_"+rowid).innerHTML;
            axios.post('api/modules/applications/updateitem', {'recordid':rowid, 'record_value':itemName}).then(function(response){
             
                self.$refs.notifyMsg.showAlert('Success', res.data.message);
            })
        },
        
        changeBudgetFile(e) {
            let filelist = e.target.files;
            const fileInput = e.target;
            this.budgetFile = [];
            this.file_error = '';
            const files = Array.from(fileInput.files);
            if (!files.length) return;
            // ----------------------------
            // 1. FILE COUNT VALIDATION
            // ----------------------------
            const MAX_FILES = 5;
            if (files.length > MAX_FILES) {
                this.file_error = "You can upload a maximum of 5 files only.";
                fileInput.value = '';
                return;
            }

            for (let i = 0; i < filelist.length; i++) {
                let image = e.target.files[i];
                 // ----------------------------
                // FILE NAME VALIDATION
                // ----------------------------
                const MAX_FILE_NAME_LENGTH = 40;

                if (image.name.length > MAX_FILE_NAME_LENGTH) {
                    this.file_error = `File name cannot exceed ${MAX_FILE_NAME_LENGTH} characters.`;
                    fileInput.value = '';
                    this.budgetFile = [];
                    return;
                }
                let fileArr = [];
                let file_type_arr = e.target.files[i].type.split("/");
                this.budgetFileName = file_type_arr;
                this.showBudgetFileName = image.name;
                // Get the file size
                let fileSize = image.size; // in bytes
                
                let setSize = window.app.max_file_size;
                let definedSize = 2097152;
                if(setSize[1] == 'M')
                {
                    definedSize = ((parseInt(setSize.slice(0,-1)) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }
                if(setSize[1] == 'G')
                {
                    definedSize = (((parseInt(setSize.slice(0,-1)) * 1024) * 1024) * 1024); ///let  bytes = megabytes * 1024 * 1024;
                }

                if(fileSize < definedSize)
                {
                    this.file_error = '';
                    let reader = new FileReader();
                    reader.readAsDataURL(image);
                    reader.onload = e => {
                        //  this.file_content = e.target.result;
                        this.UploadBudgetFile = true;
                        fileArr.push(e.target.result, this.UploadBudgetFile, file_type_arr[1], image.name);
                        this.budgetFile.push(fileArr);
                    };
                }else{
                    this.file_error = "The file size exceeds the maximum limit. Allowed file max size is "+ setSize;
                }

            }

        },

        UploadBudget(){
                const self = this;
                if(self.file_error == '')
                {
                    self.processing = true;
                    let count = 0;
                    let app_id = self.$route.params.id;
                    for (let i = 0; i < 95; i++) {
                        self.loadProgress(i);
                    }
                    axios.post('api/modules/applications/uploadBudgetFile', { 'app_id': app_id, 'filelist': self.budgetFile, headers: { 'Content-Type': 'multipart/form-data' } }).then(function (res) {
                        if (res.data.message != '') {
                            
                            self.loadProgress(95);
                            self.loadProgress(96);
                            self.loadProgress(97);
                            self.loadProgress(98);
                            self.loadProgress(99);
                            count = self.loadProgress(100);
                            if (count == 100) {
                                $("#upload_budget").val("");
                                $(".progress-bar").animate({
                                    width: "0%",
                                }, 0);
                                $("#uploadBudgetModal").modal("hide");
                                self.processing = false;
                                //self.getProduct();
                                self.getBudget();
                            }
                        }
                    }).catch(function () {
                        self.loading = false;
                    }); 
                }else{
                    this.file_error = "Please select appropriate file!";
                }
        },
        calulateBudget(itemid, templateYear, yearpos, subhead, headid, is_monthly = 'No'){
            let units = 0;
            let months = 0;
            let percent = 0;
            let cost = 0;
            let year_pos = 1;
            if(is_monthly == 'Yes')
            {
                //let paramsArr = [itemid, templateYear, yearpos, event, headname, is_monthly];
                //console.log(paramsArr)
                units = document.getElementById("units_"+itemid).value;
                months = document.getElementById("month_"+itemid).value;
                percent = document.getElementById("percent_of_time_"+itemid).value;
                cost = document.getElementById("costpermonth_"+itemid).value;
                
               if(!isNaN(units) && !isNaN(units) && !isNaN(units) && !isNaN(units))
               {

                   let i = 0;
                    if(yearpos == year_pos)
                    {
                        i = year_pos;
                    }else{
                        i = year_pos;
                    }
                    let yearvalue = 0;
                   for(i; i <= templateYear; i++)
                   {
                    
                    let yearEl = document.getElementById("year"+i+"_"+itemid);
                        if(i == 1)
                        {
                            yearvalue = parseFloat(parseFloat((cost *percent)/100)*units).toFixed(2);
                            yearvalue = parseFloat(yearvalue * months).toFixed(2)
                            yearEl.value = yearvalue;
                            yearEl.dispatchEvent(new Event('input'));
                        }else{
                            yearvalue = parseFloat((parseFloat(yearvalue*10)/100) + parseFloat(yearvalue)).toFixed(2);
                            yearEl.value = yearvalue;
                            yearEl.dispatchEvent(new Event('input'));
                        }

                   }

                   let j = 0;
                    if(yearpos == year_pos)
                    {
                        j = year_pos;
                    }else{
                        j = year_pos;
                    }
                    let totalInr = 0;
                    let totalUsd = 0;
                   for(j; j <= templateYear; j++)
                   {
                    
                    let yearEl = document.getElementById("year"+j+"_"+itemid);
                    totalInr = parseFloat(parseFloat(totalInr)+parseFloat(yearEl.value)).toFixed(2);
                   }
                   let multiplier = 0;
                   if(this.multiplier != '')
                   {
                       multiplier = this.multiplier;
                   }
                    let InrValue = document.getElementById("total_inr_"+itemid);
                        InrValue.value = totalInr; 
                        InrValue.dispatchEvent(new Event('input'));
                    let otherValue = document.getElementById("total_usd_"+itemid);
                        totalUsd = parseFloat(totalInr/multiplier).toFixed(2);
                        otherValue.value = totalUsd;
                        otherValue.dispatchEvent(new Event('input'));
                        this.calculateSubTotal(headid, subhead);
               }
            }
        },
        calulateYearwise(itemid, templateYear, yearpos, subhead, headid, is_monthly = 'No'){
            let year_pos = 1;
           
                 let i = 0;
                    if(yearpos == year_pos)
                    {
                        i = year_pos;
                    }else{
                        if(templateYear == yearpos)
                        {
                            i = templateYear;
                        }else{
                            i = yearpos;
                        }                        
                    }
                   
                    let yearvalue = 0;
                    let oldEl = document.getElementById("year"+yearpos+"_"+itemid)
                   
                    if(!isNaN(oldEl.value)){
                        if(oldEl.value !='')
                        {
                            yearvalue = oldEl.value;   
                        }else{
                            yearvalue = 0;
                        } 
                                   
                   for(i; i <= templateYear; i++)
                   {
                       if(isNaN(yearvalue))
                       {
                        yearvalue = 0
                       }
                      
                    if(i != yearpos && !isNaN(yearvalue)){
                        let yearEl = document.getElementById("year"+i+"_"+itemid);                       
                        yearvalue = parseFloat((parseFloat(yearvalue*10)/100) + parseFloat(yearvalue)).toFixed(2);
                        yearEl.value = yearvalue;
                        yearEl.dispatchEvent(new Event('input'));
                    }
                   }

                   let j = 1;
                  
                    let totalInr = 0;
                    let totalUsd = 0;
                   for(j; j <= templateYear; j++)
                   {
                    let yearValue = 0;
                    let yearEl = document.getElementById("year"+j+"_"+itemid);
                    if(yearEl.value != '')
                    {
                        yearValue = yearEl.value;
                    }else{
                        yearEl.value = 0;
                    }
                    totalInr = parseFloat(parseFloat(totalInr)+parseFloat(yearValue)).toFixed(2);
                   }
                   let multiplier = 0;
                   if(this.multiplier != '')
                   {
                       multiplier = this.multiplier;
                   }
                    let InrValue = document.getElementById("total_inr_"+itemid);
                        InrValue.value = totalInr;
                        InrValue.dispatchEvent(new Event('input'));
                    let otherValue = document.getElementById("total_usd_"+itemid);
                        totalUsd = parseFloat(totalInr/multiplier).toFixed(2);
                        otherValue.value = totalUsd;
                        otherValue.dispatchEvent(new Event('input'));
                        this.calculateSubTotal(headid, subhead);
                }
        },
        calculateSubTotal(headid, budgetItem = []){
            let totalInr = 0;
            let totalUsd = 0;

            for(let i = 0; i < budgetItem.length; i++)
            {               
                let totalInrEl = document.getElementById("total_inr_"+budgetItem[i].id);
                if(!isNaN(totalInrEl.value) && totalInrEl.value !=''){
                    totalInr = parseFloat(parseFloat(totalInr)+parseFloat(totalInrEl.value)).toFixed(2)
                }
                let totalUsdEl = document.getElementById("total_usd_"+budgetItem[i].id);
                if(!isNaN(totalUsdEl.value) && totalUsdEl.value != ''){
                totalUsd = parseFloat(parseFloat(totalUsd)+parseFloat(totalUsdEl.value)).toFixed(2)
                }

            }
           
                let inrSubEl = document.getElementById("head_inr_"+headid);                
                    inrSubEl.innerHTML = totalInr;
                    inrSubEl.dispatchEvent(new Event('input'));
                let usdSubEl = document.getElementById("head_usd_"+headid);
                    usdSubEl.innerHTML = totalUsd;
                    usdSubEl.dispatchEvent(new Event('input'));
            this.calculateGrossTotal(headid, budgetItem);
        },
        calculateGrossTotal(headid, budgetitemarr = []){
            let totalinr = 0;
            let totalUsd = 0;

            for(let i = 0; i < budgetitemarr.length; i++)
            {               
                let totalInrEl = document.getElementById("total_inr_"+budgetitemarr[i].id);
                if(!isNaN(totalInrEl.value) && totalInrEl.value !=''){
                    totalinr = parseFloat(parseFloat(totalinr)+parseFloat(totalInrEl.value)).toFixed(2)
                }
                let totalUsdEl = document.getElementById("total_usd_"+budgetitemarr[i].id);
                if(!isNaN(totalUsdEl.value) && totalUsdEl.value != ''){
                totalUsd = parseFloat(parseFloat(totalUsd)+parseFloat(totalUsdEl.value)).toFixed(2)
                }

            }
            
                let inrSubEl = document.getElementById("Ghead_inr_"+headid+"_1");                
                    inrSubEl.innerHTML = totalinr;
                    inrSubEl.dispatchEvent(new Event('input'));
                let usdSubEl = document.getElementById("Ghead_usd_"+headid+"_1");
                    usdSubEl.innerHTML = totalUsd;
                    usdSubEl.dispatchEvent(new Event('input'));
              
                this.getTotal();
        },
        getTotal(){
            const self = this;
            let totinr = 0;
            let totusd = 0;
            self.totalInr = 0;
            self.other_currency = 0;
            let budgetitemarr = self.budgetItem;

            for(let j = 0; j < budgetitemarr.length; j++)
            {    
                let subhead = budgetitemarr[j].sub_head;
                for(let i = 0; i < subhead.length; i++)
                {
                    let totalInrEl = document.getElementById("total_inr_"+subhead[i].id);
                    if(!isNaN(totalInrEl.value) && totalInrEl.value !=''){
                        totinr = parseFloat(parseFloat(totinr)+parseFloat(totalInrEl.value)).toFixed(2)
                    }
                    let totalUsdEl = document.getElementById("total_usd_"+subhead[i].id);
                    if(!isNaN(totalUsdEl.value) && totalUsdEl.value != ''){
                        totusd = parseFloat(parseFloat(totusd)+parseFloat(totalUsdEl.value)).toFixed(2)
                    }
                }
            }

            self.totalInr = parseFloat(parseFloat(self.totalInr) + parseFloat(totinr)).toFixed(2);
            self.other_currency = parseFloat(parseFloat(self.other_currency) + parseFloat(totusd)).toFixed(2);
            
        },
        downloadBudget(appTemplateId){
            const self = this;
            axios.post('api/modules/exportappbudget', { 'app_temp_id': appTemplateId, 'language':self.lang}).then(function (response) {
                //console.log(response.data);
                let jsonData = response.data;

                var blob = new Blob([jsonData]);
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = self.templateName+'.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
        },
        removeFile(fileTbl, record){
            const self = this;
            const deleteRecord = {'table': fileTbl, 'delete_id':record};

            axios.post('api/modules/applications/remove', deleteRecord).then(function(response){
                self.getProduct();
                self.getBudget();
            }).catch(function(error){
                self.loading = false;
            });
        },

        downloadPrivate(doc_id, tbl,filename) {
            const self = this;
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Please login to download files');
                return;
            }
            
            axios.get(`api/modules/download/${doc_id}/${tbl}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => {
                //console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error('Download failed:', error);
                self.$refs.notifyMsg.showAlert('Error', 'Download failed. File may not exist or access denied.');
            });
        }
    }
}
